module.exports = __webpack_public_path__ + "static/media/img_mp.937502eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_mp.png
// module id = 381
// module chunks = 4